import { render, staticRenderFns } from "./DictRadio.vue?vue&type=template&id=5f97dad8&"
import script from "./DictRadio.vue?vue&type=script&lang=js&"
export * from "./DictRadio.vue?vue&type=script&lang=js&"
import style0 from "./DictRadio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports